import { render } from "./PatientInfo.vue?vue&type=template&id=2dff1a70&scoped=true&ts=true"
import script from "./PatientInfo.vue?vue&type=script&lang=ts"
export * from "./PatientInfo.vue?vue&type=script&lang=ts"

import "./PatientInfo.vue?vue&type=style&index=0&id=2dff1a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dff1a70"]])

export default __exports__